import { render } from "./WebsiteBackground.vue?vue&type=template&id=20d4579e"
const script = {}

import "./WebsiteBackground.vue?vue&type=style&index=0&id=20d4579e&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__